import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { JsonLd } from "@/components/JsonLd";
import { Faq } from "@/components/Faq";
import { AdSlot } from "@/components/AdSlot";
import { Card } from "@/components/ui/card";
import BetonRechner from "@/components/beton/BetonRechner";
import { BETON_SEITEN, BETON_HUB } from "@/lib/betonSeiten";

const HUB_FAQ = BETON_HUB.faq;

export default function BetonHubPage() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = origin ? `${origin}/${BETON_HUB.slug}` : undefined;

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "Betonrechner",
      url: canonical,
      applicationCategory: "UtilityApplication",
      operatingSystem: "Web",
      offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
      inLanguage: "de-DE",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: HUB_FAQ.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <Seo title={BETON_HUB.title} description={BETON_HUB.description} canonical={canonical} />
      <JsonLd data={jsonLd} />

      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">{BETON_HUB.h1}</h1>
      <p className="mt-3 text-muted-foreground leading-relaxed">
        Wähle dein Bauteil, gib die Maße ein und du bekommst sofort die benötigte Betonmenge in Kubikmeter, die Anzahl Trockenbeton-Säcke und das Gewicht. Kostenlos, ohne Anmeldung, eine Schätzung für die Materialbestellung.
      </p>

      <div className="mt-6">
        <BetonRechner preset="bodenplatte" />
      </div>

      <div className="mt-8"><AdSlot variant="banner" /></div>

      <section className="mt-8">
        <h2 className="text-xl font-semibold mb-3">Beton für ein konkretes Bauteil</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          {BETON_SEITEN.map((s) => (
            <Link key={s.slug} to={`/${s.slug}`} className="block">
              <Card className="p-4 h-full hover:shadow-md transition-shadow">
                <div className="font-semibold text-sm">{s.h1}</div>
                <div className="text-sm text-muted-foreground mt-1">{s.description}</div>
              </Card>
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-10">
        <h2 className="text-xl font-semibold mb-4">Häufige Fragen</h2>
        <Faq items={HUB_FAQ} testId="beton-hub-faq" />
      </section>

      <div className="mt-10"><AdSlot variant="banner" /></div>
    </div>
  );
}
